<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <div class="d-flex align-center">
      <v-btn
        class="mini"
        :disabled="value <= 0 || disabled"
        :fab="!square"
        :tile="square"
        :outlined="square"
        depressed
        style="margin-right:-1px"
        @click="$emit('update:minus', +value - 1)"
      >
        <v-icon size="14">
          mdi-minus
        </v-icon>
      </v-btn>
      <div
        style="max-width:60px;"
      >
        <v-text-field
          :value="value"
          :class="square ? 'rounded-0' : 'border-none'"
          :flat="square ? false : true"
          dense
          type="number"
          class="text-center no-appearance x-small"
          color="primary"
          outlined
          hide-details
          @change="$emit('update:value', +$event >= 0 ? +$event : 0)"
        />
      </div>
      <v-btn
        class="mini"
        :fab="!square"
        :tile="square"
        :outlined="square"
        depressed
        style="margin-left:-1px"
        @click="$emit('update:plus',+value + 1)"
      >
        <v-icon size="14">
          mdi-plus
        </v-icon>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'Stepper',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    square: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      // vRules: [(v) => v > 0 || 'You should purchase at least one product'],
    };
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>

</style>
